import { Location } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Temporal } from '@js-temporal/polyfill';
import { db } from 'src/app/db/db';
import { MeasureMassif } from 'src/app/domain/Massif/measure-massif';
import { EditTextBoxDialog } from 'src/app/tools/ui/edit-text-box/edit-text-box';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
type Reference = { mrCode: string; mrName: string };

@Component({
    selector: 'app-massif',
    templateUrl: './massif.component.html',
    styleUrls: ['./massif.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MassifComponent implements OnInit {
    public Model: MeasureMassif = new MeasureMassif()
    samplingTime = '';
    SamplingDate: Date | null = null;
    private code: string = '';
    interventionCode: string = '';

    AvailableMeasureOnThisInterventionList: Reference[] = []

    constructor(
        private dialog: MatDialog,
        private location: Location,
        private snackBar: MatSnackBar,
        private route: ActivatedRoute) { }

    async ngOnInit(): Promise<void> {
        this.code = this.route.snapshot.params?.['code'];
        this.interventionCode = this.route.snapshot.params?.['interventionCode'];

        this.AvailableMeasureOnThisInterventionList = (await db.getInterventionByCode(Number(this.interventionCode))).ProcessList.flat().map(x => {
            return {
                mrCode: x.ProcessMesure.Code,
                mrName: x.Name
            }
        });

        if (this.code) {
            this.Model = await db.getMeasureMassifByCode(this.code);
            if (this.Model.SamplingTime) {
                this.SamplingDate = new Date();
                this.SamplingDate.setHours(this.Model.SamplingTime.hour, this.Model.SamplingTime.minute);
                this.setTimeSamplingDate();
            }
        }
    }

    timeSetSamplingDate(event: string) {
        const [hours, minutes] = event.split(':').map(Number);
        const samplingDate = new Date(this.SamplingDate ?? new Date());
        samplingDate.setHours(hours, minutes, 0, 0);
        this.SamplingDate = samplingDate;
        this.Model.SamplingTime = Temporal.PlainTime.from({ hour: hours, minute: minutes });
        this.setTimeSamplingDate();
    }

    private setTimeSamplingDate() {
        this.samplingTime = `${String(this.SamplingDate!.getHours()).padStart(2, '0')}:${String(this.SamplingDate!.getMinutes()).padStart(2, '0')}`;
    }

    cancelMeasure() {
        const dialogRef = this.dialog.open(EditTextBoxDialog, { data: { title: 'Veuillez indiquer le motif de l\'annulation', withCancelButton: true } });
        dialogRef.afterClosed().subscribe(async (result: string) => {
            if (result) {
                await db.cancelMeasureMassif(this.Model, result);
                NotificationManager.handleSuccess('Mesure annulée', this.snackBar);
                this.location.back()
            }
        })
    }

    async save() {
        const success = await db.updateMeasureMassif(this.Model);
        if (success) {
            NotificationManager.handleSuccess('Mesure enregistrée', this.snackBar);
            this.location.back()
        } else if (!success) {
            NotificationManager.handleError('Wasted Bro!', this.snackBar);
        }
    }
}
